<h1 mat-dialog-title>{{ 'SITE_INVESTIGATION/table/id' | translate }}: {{data.site.id}}</h1>
<div mat-dialog-content>
  <p>{{ 'SITE_INVESTIGATION/dialog/approve' | translate }}</p>
</div>
<div mat-dialog-actions>
   <button mat-button class="primary-button" (click)="onClickOk()" cdkFocusInitial>{{ 'SITE_INVESTIGATION/dialog/btn/ok' | translate }}</button>
</div>
